import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
  PLATFORM_ID,
  inject,
  signal,
} from '@angular/core';
import { MatSliderModule } from '@angular/material/slider';
import { ActivatedRoute, Router } from '@angular/router';
import { FiltersItems } from '@core/models/domains/filters.model';
import { SharedModule } from '@shared/shared.module';
import { SearchResultUiService } from '../../../services/search-result-ui.service';
import { RialToTomanPipe } from '@shared/pipes/rial-to-toman.pipe';
import { SliderangeComponent } from '@shared/components/sliderange/sliderange.component';
import { isPlatformBrowser } from '@angular/common';
@Component({
  selector: 'iho-price-filter',
  templateUrl: './price-filter.component.html',
  styleUrls: ['./price-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    SharedModule,
    MatSliderModule,
    RialToTomanPipe,
    SliderangeComponent,
  ],
  providers: [RialToTomanPipe],
})
export class PriceFilterComponent implements OnInit {
  constructor( @Inject(PLATFORM_ID) public platformId: Object,){

  }
  @Input() _minValue!: number | string;
  @Input() _maxValue!: number | string;
  @Input() set _reset(value: boolean) {
    this.reset.set(!this.reset());
  }
  minValue = signal<number>(0);
  maxValue = signal<number>(1000);
  initMin = 0;
  reset = signal(false);
  initMax = 33333;
  flagValue?: number = undefined;
  searchResultUiService = inject(SearchResultUiService);
  RialToTomanPipe = inject(RialToTomanPipe);
  loading = true

  @Output() checkedMinValue = new EventEmitter();
  @Output() checkedMaxValue = new EventEmitter();
  @Input() dataSource: FiltersItems[] = [];

  ngOnInit() {
    this.minValue.set(+this.dataSource[0].Value);
    this.maxValue.set(+this.dataSource[1].Value);
  if (isPlatformBrowser(this.platformId)){
    setTimeout(() => {
      this.loading = false
    }, 2000);

  }
   
  }

  changeMinVal(ev: any) {
    this.minValue.set(+ev.toFixed(0));
  }

  changeMaxVal(ev: any) {
    this.maxValue.set(+ev.toFixed(0));
  }

  minValueChanged(event: any) {
    this.checkedMinValue.emit(this.minValue().toFixed(0));
  }

  maxValueChanged(event: any) {
    this.checkedMaxValue.emit(this.maxValue().toFixed(0));
  }
}
